<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item>
      <nz-form-item class="mb-3">
        <nz-form-label class="text-left" [nzSm]="24" [nzXs]="24">
          Задание
        </nz-form-label>
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <nz-select [(ngModel)]="leadsService.filterWork" [ngModelOptions]="{standalone: true}"
                     (ngModelChange)="setFilterWork($event)"
                     nzShowSearch nzAllowClear nzPlaceHolder="Выберите">
            <nz-option *ngFor="let data of leadsService.leadTasks$ | async"
                       [nzLabel]="data.name" [nzValue]="data.id">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </li>
  </ul>
</nz-dropdown-menu>
<button
  nz-dropdown
  [nzTrigger]="'click'"
  [nzClickHide]="false"
  [nzDropdownMenu]="menu"
  class="filter-button" nz-button [nzType]="leadsService.filterWork > 0 ? 'primary' : 'default'" nzShape="circle">
  <i-feather name="filter"></i-feather>
</button>
